module.exports = __webpack_public_path__ + "static/media/izlozba (7).acb8a17c.jpg";